import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Config } from "src/app/models/config.model";
import { FileStatus, UploadFile } from "src/app/models/uploadfile.model";
import { ConfigService } from "src/app/services/config.service";
import { UploadService } from "src/app/services/upload.service";

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit, OnDestroy {

    private componentDestroyed: Subject<any> = new Subject();

    @ViewChild('fileDropRef', { static: false }) fileDropRef!: ElementRef;

    config!: Config | undefined;

    formatBytes = this.uploadService.formatBytes;

    isUploading: boolean = false;

    get files(): UploadFile[] {
        return this.uploadService.files;
    }

    constructor(private uploadService: UploadService, private configService: ConfigService) {

        this.configService.config
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe(
                (config: Config | null) => {
                    if (config !== null) {
                        this.config = config;
                    }
                }
            );

        this.uploadService.isUploading
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe(
                (value: boolean) => {
                    this.isUploading = value;
                }
            );
    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.componentDestroyed.next(null);
        this.componentDestroyed.unsubscribe();
    }

    showImageBrowseDlg() {
        this.fileDropRef.nativeElement.click()
    }

    fileBrowseHandler(e: Event) {

        if (this.isUploading) {
            return;
        }

        const input = e.target as HTMLInputElement;

        if (input !== undefined) {
            if (input.files && input.files.length > 0) {
                this.uploadService.addFiles(input.files);
                this.fileDropRef.nativeElement.value = '';
            }
        }
    }

    removeFile(uploadFile: UploadFile) {
        if (!this.isUploading) {
            this.uploadService.removeFile(uploadFile, true);
          }
    }

    openFile(uploadFile: UploadFile) {
        this.uploadService.downloadFile(uploadFile);
    }

    clearFiles(hardDelete: boolean, notify: boolean) {
        this.uploadService.clearFiles(hardDelete, notify);
    }
}
